import {IModuleConfig} from "@kta20-core/interfaces/base-module";
import {MODULE_CLASS_NAME} from "@kta20-ui-base/constants";

export class UiBaseModuleConfig implements IModuleConfig {
    name:string = MODULE_CLASS_NAME;
    constructor(public viewsToPreload:string[]=[]) {}
}